import urlsService from '@/services/urls-service';
import { baseApi } from './baseApi';
import { transformGetProductsById } from './transformProductApiResponse';
import type * as Types from '@/stores/productsApiTypes';

export interface ISearchVariantsResponse {
  total: number;
  results: IProductVariantSearchResult[];
}

export interface IProductVariantSearchResult {
  productCode: string;
  code: string;
  title: string;
  url: string;
  imageUrl: string;
  unitOfMeasure: IUnitOfMeasure;
}
export interface IUserPriceByCodeRequest {
  variantCode: string;
  unitOfMeasureCode: string;
}

type IUserPricesRequest = IUserPriceByCodeRequest[];

export type IUserPriceByCodeResponse = Omit<IProductPrices, 'old'>;
export const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchVariants: builder.query<ISearchVariantsResponse, string>({
      query: (searchTerm) => ({
        url: urlsService.getUrl(`/products/variants?s=${searchTerm}`),
        method: 'GET'
      })
    }),
    getUserPrices: builder.query<IUserPriceByCodeResponse[], IUserPricesRequest>({
      query: (data: IUserPricesRequest) => ({
        url: urlsService.getUrl('/products/prices'),
        method: 'POST',
        body: data
      })
    }),
    getUserPriceByCode: builder.query<IUserPriceByCodeResponse, IUserPriceByCodeRequest>({
      query: ({ variantCode, unitOfMeasureCode }) => ({
        url: urlsService.getUrl(`/products/prices/${variantCode}/${unitOfMeasureCode}`),
        method: 'GET'
      })
    }),
    getProductByCode: builder.query<Types.Product | undefined, string>({
      query: (productCode) => ({
        url: urlsService.getUrl('/products/'),
        method: 'POST',
        body: [productCode]
      }),
      transformResponse: (data: Types.ApiProduct[]) => {
        const transformedResponse = transformGetProductsById(data);
        return transformedResponse?.at(0);
      }
    }),
    getProductsByCode: builder.query<Types.Product[] | undefined, string[]>({
      query: (productCodes) => ({
        url: urlsService.getUrl('/products/'),
        method: 'POST',
        body: productCodes
      }),
      transformResponse: (data: Types.ApiProduct[]) => transformGetProductsById(data)
    })
  }),
  overrideExisting: true
});

/* eslint-disable prettier/prettier */
export const {
  useSearchVariantsQuery,
  useLazySearchVariantsQuery,
  useGetUserPricesQuery,
  useLazyGetUserPricesQuery,
  useGetUserPriceByCodeQuery,
  useLazyGetUserPriceByCodeQuery,
  useGetProductByCodeQuery,
  useLazyGetProductByCodeQuery,
  useGetProductsByCodeQuery,
  useLazyGetProductsByCodeQuery
} = productsApi;
